import { Component } from '@angular/core';
import { Route } from '../../utils/route';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { IdBrowserTabComponent } from './id-browser-tab/id-browser-tab.component';

@Component({
  selector: 'app-id-browser',
  imports: [TabsComponent, IdBrowserTabComponent],
  templateUrl: './id-browser.component.html',
  styleUrl: './id-browser.component.scss',
})
export class IdBrowserComponent extends Route {}
